import { useCallback } from "react";
import * as React from "react";
import { ShowMore as ShowMoreComponent } from "@ppb/the-wall-web";
import { ComponentPropsWeb, i18nLabels } from "./props";
import { scrollCardIntoView } from "../../helpers/scroll-card-into-view.web";

const ShowMore: React.FC<ComponentPropsWeb> = ({
  numberOfItemsToDisplay,
  numberOfLines,
  showMore,
  setShowMore,
  cardRef, // FIXME: cardRef should be a Ref to the card element to avoid unnecessary re-renders
  isHighlighted = false,
  onToggleShowMoreRunners,
}) => {
  const toggleShowMore = useCallback(() => {
    if (!showMore) {
      scrollCardIntoView(cardRef);
    }

    setShowMore(!showMore);

    onToggleShowMoreRunners(showMore);
  }, [cardRef, onToggleShowMoreRunners, setShowMore, showMore]);

  if (!numberOfLines || !numberOfItemsToDisplay || numberOfLines <= numberOfItemsToDisplay) {
    return null;
  }

  return (
    <ShowMoreComponent
      onClick={toggleShowMore}
      text={showMore ? i18nLabels.showMore : i18nLabels.showLess}
      opened={!showMore}
      isHighlighted={isHighlighted}
    />
  );
};

export default ShowMore;
